<template>
	<HeroLayout>
		<div class="flex flex-col h-full">
			<img :src="logoLargePath" alt="Logo" class="registration-title-image" />
			<div class="flex flex-col items-center w-fit py-8 px-15 mt-11 rounded-2xl border border-neutral border-solid bg-neutral card-shadow">
				<img src="@/assets/images/icon/confetti.svg" alt="Success" title="Success" />
				<StepIndicator class="mt-6" :current_step="5" :total_steps="4" />
				<p class="registration-title mt-6">Congratulations!</p>
				<p class="registration-subtitle">Your account is created and ready to go.</p>
				<SubmitButton class="mx-auto mt-8" label="Go to Portal" @click="goToPortal" />
			</div>
		</div>
	</HeroLayout>
</template>

<script setup lang="js">
import StepIndicator from '@/components/Registration/StepIndicator.vue'
import router from '@/router/router.js'
import HeroLayout from '@/layouts/HeroLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import { onMounted, ref } from 'vue'
import { Tenants } from '@/models/tenants/Tenants.js'
import { useAuthStore } from '@/stores/authStore.js'

const logoLargePath = ref('')
const authStore = useAuthStore()

onMounted(() =>
{
	const tenant = Tenants.getTenant()
	logoLargePath.value = new URL(`../../assets/images/theme/${tenant.registrationLogo.image}`, import.meta.url).href
})

function goToPortal()
{
	authStore.userpilotIdentify();
	router.push({ name: 'dashboard' })
}
</script>

<style scoped>

.card-shadow {
	box-shadow: 0 4px 4px 0 rgba(17, 24, 25, 0.25);
}

</style>